import { categories, categoryImages } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="relative w-full py-20 md:py-28 bg-background-100">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">
        <div className="mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-extralight text-foreground-950 mb-3 leading-tight">
            Escolha por Categoria
          </h2>
          <p className="text-base md:text-lg text-foreground-500 font-light max-w-[520px]">
            Navegue pelas nossas categorias e descubra produtos incríveis em cada secção.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6" data-product-shop="">
          {categories.map((cat) => (
            <a
              key={cat.id}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group block rounded-2xl overflow-hidden bg-background-50 border border-background-200/60 hover:border-background-300 transition-all duration-300"
            >
              <div className="relative aspect-[4/3] overflow-hidden">
                <img
                  src={categoryImages[cat.id]}
                  alt={`${cat.name} - HoobuySpreadsheet`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                  title={`${cat.name} - HoobuySpreadsheet`}
                />
              </div>
              <div className="p-5">
                <h3 className="text-base md:text-lg font-heading font-medium text-foreground-900 mb-1">
                  {cat.name}
                </h3>
                <p className="text-sm text-foreground-500 font-light mb-4">
                  Ver melhores ofertas
                </p>
                <span className={`inline-flex items-center justify-center w-full py-2.5 rounded-full text-sm font-medium transition-all whitespace-nowrap ${
                  cat.accent
                    ? 'bg-foreground-900 text-background-50 group-hover:bg-foreground-800'
                    : 'bg-background-100 text-foreground-800 border border-background-200 group-hover:bg-background-200'
                }`}>
                  Ver {cat.name}
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}